export default __webpack_public_path__ + "static/media/GLTD_Class_1_Plan_Brochure.488aa58e.pdf";